function parseJoiMessage(message: any) {
  if (message.response && message.response.request && message.response.request.response) {
    console.log(message.response.request.response);
    message = JSON.parse(message.response.request.response);
  }

  const fields: any = [];
  if (message.response && message.response.data && message.response.data.errors && Object.values(message.response.data.errors).length > 0) {
    for (const field of Object.values(message.response.data.errors)) {
      // @ts-ignore
      if (field.hasOwnProperty('messages') && field.messages) {
        // @ts-ignore
        fields.push(field.messages[0]);
      }
    }
    return fields.join('<br/>');
  } else if (message.message) {
    return message.message;
  } else if (message.msg) {
    return message.msg;
  }
  return message;
}

// @ts-ignore
export const stop = async ({commit}) => {
  commit('stop');
};

// @ts-ignore
export const warning = async ({commit}, message) => {
  commit('start', {message: parseJoiMessage(message), color: 'warning'});
};

// @ts-ignore
export const danger = async ({commit}, message) => {
  commit('start', {message: parseJoiMessage(message), color: 'error'});
};

// @ts-ignore
export const error = async ({commit}, message: Error | string) => {
  commit('start', {message: parseJoiMessage(message), color: 'error'});
};

// @ts-ignore
export const notify = async ({commit}, message) => {
  commit('start', {message: parseJoiMessage(message), color: 'orange darken-1'});
};

// @ts-ignore
export const info = async ({commit}, message) => {
  commit('start', {message: parseJoiMessage(message), color: 'info'});
};

// @ts-ignore
export const success = async ({commit}, message) => {
  commit('start', {message: parseJoiMessage(message), color: 'success'});
};
